<template>
	<div v-if="isLoaded">
        <b-row v-for="(col, index) in schema" :key="index">
            <b-col>
                <b-row align-h="start" class="mt-1">
                    <b-col style="text-align: left; font-weight: bold">
                        <b-row>
                            <b-col cols="4" sm="3" md="2" lg="2" xl="2">
                                <span>{{ $t(col.header) }}</span>
                            </b-col>
                            <span style="text-align: left">:</span>
                            <div style="margin-left: 10px">
                                <div  v-if="isEditable && col.editable">
                                    <template v-if="col.type === 'date'">
                                        <el-date-picker
                                            v-model="model[col.key].value"
                                            type="date"
                                            :readonly="!col.editable"
                                            format="dd/MM/yyyy"
                                            :placeholder="$t('chooseDatePlaceholder')"
                                            @focus="errors[col.key] = false"
                                            style="width: 220px"/>
                                    </template>
                                    <template v-else>
                                        <b-form-input
                                            v-model="model[col.key].value"
                                            @focus.native="errors[col.key] = false"
                                            :class="{'is-invalid': errors[col.key] }"
                                            style="width: 220px"/>
                                    </template>
                                </div>
                                <div v-else>
                                    <template v-if="col.type === 'date'">
                                        {{ model[col.key].value |  formatDate('DD-MM-YYYY') }}
                                    </template>
                                    <template v-else>
                                        {{ model[col.key].value }}
                                    </template>
                                </div>
                            </div>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
    <div v-else></div>
</template>

<script>
export default {
    name: 'CustomForm',
    props: {
        schema: {
            required: true,
            type: Array,
            default: () => []
        },
        data: {
            required: true,
            type: Object
        },
        isEditable: {
            required: true,
            type: Boolean
        },
        emptyFields: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            isLoaded: false,
            model: {},
            errors: {}
        };
    },
    methods: {},
    watch: {
        model: {
            handler(newValue) {
                let data = {};
                this.schema.forEach(col => {
                    data[col.key] = newValue[col.key].value;
                });
                this.$emit('formChange', data);
            },
            deep: true
        },
        emptyFields(newVal) {
            newVal.forEach(key => {
                this.errors[key] = true;
            });
        }
    },
    created() {
        this.isLoaded = false;
        this.schema.forEach(col => {
            this.$set(this.model, col.key, {});
            this.$set(this.model[col.key], 'value', this.data[col.key] ? this.data[col.key] : null);
            this.$set(this.errors, col.key, false);

            if (col.editable) {
                this.errors[col.key] = false;
            }
        });
        this.isLoaded = true;
    }
};
</script>

<style scoped>
</style>

<i18n src="../i18n/common.json"></i18n>



// WEBPACK FOOTER //
// src/components/CustomForm.vue